import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { TestimonialSection } from './components/TestimonialSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-tactical-950 text-gray-200 selection:bg-cyan-accent/30 selection:text-white scroll-smooth" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main className="pt-[72px] md:pt-[60px]" data-id="element-2">
        {' '}
        {/* Padding for sticky urgency bar */}
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <TestimonialSection data-id="element-7" />
        <CtaSection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}